import { render } from "./PageTeams.vue?vue&type=template&id=74dbe65d"
import script from "./PageTeams.vue?vue&type=script&lang=js"
export * from "./PageTeams.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__